import { call, put, select } from 'redux-saga/effects';
import { setCanAddToProfile } from '../modules/Filters';
import superagent from 'superagent';
import { getEndpoints, getIsAuthenticated } from '../modules/Settings';

const deepEqual = (a, b, keys) => {
  const [aType, bType] = [typeof a, typeof b];
  if (aType !== bType) return false;
  if (a && aType === 'object') return (keys || Object.keys(a).concat(Object.keys(b))).reduce((equal, key) => equal && deepEqual(a[key], b[key]), true);
  return a === b;
};

const getLocationFromAutocomplete = async({ keyword = '', point, locations, autoCompleteApi }) => {
  const escapedKeyword = keyword.replace(/( |,)/g,'').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, '').substr(0, 15);
  const { body: { results } } = await superagent.get(`${autoCompleteApi}location?l=4&q=${escapedKeyword}`);
  return results.find(location => (location.latlon.join(',') === point || location.fqn === locations) && location.type !== 'postcode' && location.type !== 'outcode' && location.name !== 'International');
};

const isLocationOnProfile = ({ location, intUserProfile }) => {
  if (!intUserProfile || !intUserProfile.aspirationalLocations) return false;
  return intUserProfile.aspirationalLocations.find(al => deepEqual(al, location, ['name', 'country', 'type', 'latlon', 'fqn']));
};

const checkLocations = async ({ searchDetails: { displayLocation, point, locations }, intUserProfile, autoCompleteApi }) => {
  if (!(displayLocation || point || locations)) return null;

  const matchingLocation = await getLocationFromAutocomplete({ keyword: (displayLocation || (locations || '').split(':').pop()), point, locations, autoCompleteApi });
  if (matchingLocation && !isLocationOnProfile({ location: matchingLocation, intUserProfile })) {
    return { aspirationalLocations: [ matchingLocation ] };
  }

  return null;
};

export function* generateAddToProfileData({ searchDetails, intUserProfile }) {
  try {
    const isLoggedIn = yield select(getIsAuthenticated);
    if (!intUserProfile || !isLoggedIn) return yield put(setCanAddToProfile(null));

    const { autoCompleteApi } = yield select(getEndpoints);
    
    const canBeAdded = {};
    Object.assign(canBeAdded, yield call(checkLocations, { searchDetails, intUserProfile, autoCompleteApi }));

    yield put(setCanAddToProfile(Object.keys(canBeAdded).length ? canBeAdded : null));
  } catch (e) {
    console.error(e);
  }
}
